import axios from '@/axiosInterceptor';

const state = () => ({});

// getters
const getters = {};

// actions
const actions = {
  async createEditRequest(_, payload) {
    const body = {
      edit_request: {
        carrier_id: payload.carrier_id,
        message: payload.message,
      },
    };
    try {
      let res = await axios.post(
        process.env.API_MONITOR + '/api/v1/edit_requests',
        body
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
